import { render, staticRenderFns } from "./SimplePDFViewer.vue?vue&type=template&id=79b0f056&"
import script from "./SimplePDFViewer.vue?vue&type=script&lang=js&"
export * from "./SimplePDFViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports